import { tv } from "tailwind-variants";

const pulseVariants = tv({
  base: "h-3 w-full animate-pulse rounded-md bg-surface-active",
});

type PulseProps = {
  className?: string;
  containerClassName?: string;
};

export const Pulse = ({ className, containerClassName }: PulseProps) => {
  return (
    <div className={containerClassName}>
      <div className={pulseVariants({ className })} />
    </div>
  );
};
